import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const StepLineIcon: React.FC<Props> = (props) => {
  return (
    <svg
      width="1280"
      height="68"
      viewBox="0 0 1280 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.5"
        d="M1279.01 50.0415C1249.81 74.8747 1186.51 60.3887 1158.51 50.0415C1125.84 30.0415 1009.62 -12.3582 964.021 28.0418C918.421 68.4418 794.021 59.5416 737.521 50.0415C674.021 35.375 526.938 -2.58199 475.521 28.0418C374.01 88.5 204.51 77.5002 118.01 1.50001C93.8436 -0.805497 31.7103 1.27515 -23.4897 28.0418"
        stroke="#0C365C"
      />
    </svg>
  );
};

export default StepLineIcon;
